import type {ReferralSetting} from 'src/types/referral-v2';
import * as React from 'react';
import {useSelector} from 'react-redux';
import {selectReferralSetting} from 'src/selectors/referral-settings';
import ReferralJobListAdvanceSettings from 'src/components/referral-job-list/settings/one-time-settings';
import css from 'src/components/referral-v2/configure/configure.css';


const OneTimeSettings = () => {
  const referralSettings: ReferralSetting | null | undefined = useSelector(
    selectReferralSetting,
  );

  return (
    <div className={css.generalNotificationsContent}>
      <ReferralJobListAdvanceSettings referralSettings={referralSettings} />
    </div>
  );
};

export default OneTimeSettings;
